import React from 'react';
import {ROUTES} from "../utils/constants";
import HeaderContainer from "../containers/HeaderContainer"
import {Link} from "react-router-dom";

const Error500 = (props) => {
  return (
    <div>
      <HeaderContainer/>
      <div className="page-container">
        <div className="not-found">
          <div className="error-msg">Uh oh! An error has occurred. Please contact <a href="mailto:studio.support@vitalsource.com">studio.support@vitalsource.com</a>.</div>
          <div className="not-found__home-link"><Link to={ROUTES.PROJECTS}>Return Home</Link></div>
        </div>
      </div>
    </div>
  );
};

export default Error500;
